module.exports = __webpack_public_path__ + "static/media/slider2.cdb89063.png";